// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__JPZA2","noselect":"Navbar_noselect__7eRtf","active":"Navbar_active__l7FQP","menuclick":"Navbar_menuclick__wBDQ5","menuhover":"Navbar_menuhover__UBi0r"};